import { AlertCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

interface QueryErrorProps {
  onRetry?: () => void
}

export function QueryError({ onRetry }: QueryErrorProps) {
  const { t } = useTranslation('common')

  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-destructive/30 bg-destructive/10 py-16">
      <AlertCircle className="mb-4 size-10 text-destructive" />
      <p className="text-sm font-medium text-destructive">{t('errors.generic')}</p>
      <p className="mt-1 text-sm text-muted-foreground">{t('errors.serverError')}</p>
      {onRetry && (
        <Button variant="outline" size="sm" className="mt-4" onClick={onRetry}>
          {t('tryAgain')}
        </Button>
      )}
    </div>
  )
}
